import { NotifyModalStyled } from "./notify-modal.styles";
import DialogComponent from "../../../../../components/dialog-component/dialog-component";
import { Button } from "../../../../../components/button/button";
import { Box } from "@mui/material";

const NotifyModal = ({ data, onClose, btnProps }: any) => {
  return (
    <DialogComponent
      open
      title="Send Confirmation Email"
      content={
        <NotifyModalStyled>
          <Box>
            Are you sure want to send email to <strong> {data?.name}</strong> as
            you are going toward <strong> {data?.address}</strong>?
          </Box>
          <Button {...btnProps}>Send</Button>
        </NotifyModalStyled>
      }
      onClose={onClose}
    />
  );
};

export default NotifyModal;
